















































































import {
  getSalarySettingDetailApi,
  setSalaryExperienceIncludeApi,
} from "@/api/salary";
import { Vue, Prop, Component } from "vue-property-decorator";
@Component
export default class extends Vue {
  form = {
    make_up_lesson_student: false,
    experience_lesson_student: false,
    missed_class_lesson_consume: false,
    valid_lesson: false,
  };
  dialogVisible: boolean = false;
  getSetting() {
    getSalarySettingDetailApi().then((res: any) => {
      this.form = {
        make_up_lesson_student: res.data.make_up_lesson_student === 1,
        experience_lesson_student: res.data.experience_lesson_student === 1,
        missed_class_lesson_consume: res.data.missed_class_lesson_consume === 1,
        valid_lesson: res.data.valid_lesson === 1,
      };
    });
  }
  openDialog() {
    this.getSetting();
    this.dialogVisible = true;
  }
  handleClose() {
    this.dialogVisible = false;
  }
  setStatus() {
    const params = {
      make_up_lesson_student: this.form.make_up_lesson_student ? 1 : 2,
      valid_lesson: this.form.valid_lesson ? 1 : 2,
      experience_lesson_student: this.form.experience_lesson_student ? 1 : 2,
      missed_class_lesson_consume: this.form.missed_class_lesson_consume
        ? 1
        : 2,
    };
    setSalaryExperienceIncludeApi(params)
      .then(() => {
        this.$message({
          type: "success",
          message: "设置成功",
        });
      })
      .catch(() => {
        this.getSetting();
      });
  }
}
